module.exports = __webpack_public_path__ + "static/media/SpookrLogo.a7458272.png";